exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search.x-row {\n  align-items: flex-start;\n}\n.title {\n  color: aliceblue;\n  text-align: center;\n}\n.has-more {\n  color: red;\n  font-weight: 700;\n}\nmain.el-main {\n  padding: 4px;\n}\n.out-header {\n  background-color: #7e331d;\n  box-shadow: 0px 2px 3px #063b44;\n  border-bottom-right-radius: 4px;\n}\n.in-header {\n  background-color: #017369;\n  box-shadow: 0px 2px 3px #063b44;\n  border-bottom-right-radius: 4px;\n}\n.el-header {\n  padding: 0 4px;\n}\n.sum_dropdown_btn button:first-of-type {\n  width: 80%;\n}\n.sum_dropdown_btn button:last-of-type {\n  width: 20%;\n}\n", ""]);

// exports
